import type { ReminderSettingsRepository } from '../repositories/reminder-settings-repository';

export class SubscribeMessageTestSendedUseCase {
  constructor(private readonly repository: ReminderSettingsRepository) {}

  execute(
    userId: string,
    onNext: (sended: boolean) => void,
    onError?: (error: Error) => void
  ): () => void {
    return this.repository.subscribeMessageTestSendedFlag(userId, onNext, onError);
  }
}
